/**
 * 无内容时的占位符（HTML &ndash;，en dash）
 */
export const EMPTY_PLACEHOLDER = '\u2013';

/**
 * 论坛权益白名单：可关联专家的权益名称
 * 当权益分类为论坛（type=4）且权益名称在此白名单中时，显示「关联专家」功能
 */
export const FORUM_EXPERT_BENEFIT_NAMES = ['开场致辞', 'VIP区席位', '对话发言', '学术报告（限15分钟）', '香蕉会场', '苹果会场'];

/** 机构名义选项 */
export const TITLE_OPTIONS = [
    { value: '战略合作伙伴', label: '战略合作伙伴' },
    { value: '合作伙伴', label: '合作伙伴' },
    { value: '特别支持', label: '特别支持' },
    { value: '独家合作汽车品牌', label: '独家合作汽车品牌' },
    { value: '鸣谢', label: '鸣谢' },
];

/**
 * 权益分类定义（唯一数据源，id/name 格式）
 * id 为后端固定码值（benefitTypes / benefit.type），name 为展示标题。
 * 顺序即展示顺序；OrganizationList.jsx 的筛选下拉、分类分组标题均由此派生。
 * 码值：1-数字化平台 2-大会展览展示 3-手册广告 4-论坛 5-其他 6-专题会 7-线上运营传播 8-效果营销 9-资源合作 10-注册参会
 */
export const BENEFIT_CATEGORIES = [
    { id: 1, name: '数字化平台' },
    { id: 2, name: '大会展览展示' },
    { id: 3, name: '手册广告' },
    { id: 4, name: '论坛' },
    { id: 6, name: '专题会' },
    { id: 7, name: '线上运营传播' },
    { id: 8, name: '效果营销' },
    { id: 9, name: '资源合作' },
    { id: 10, name: '注册参会' },
    { id: 5, name: '其他' },
];

/** 权益分类 id -> name 映射（由 BENEFIT_CATEGORIES 派生） */
export const BENEFIT_CATEGORY_MAP = Object.fromEntries(BENEFIT_CATEGORIES.map(({ id, name }) => [id, name]));
/** 价格参照问号提示固定文案（自定义权益不展示问号） */
export const PRICE_REFERENCE_TIP = '价格参照以平台大会建议，其它可视会议规模上下浮动。';

/** 日程展示单位类型选项（fieldNames: value='id', label='name'） */
export const SCHEDULE_TYPE_LIST = [
    { id: 1, key: 1, name: '主办单位', sort: 1, hide: 1 },
    { id: 4, key: 4, name: '学术支持', sort: 2, hide: 1 },
    { id: 2, key: 2, name: '协办单位', sort: 3, hide: 1 },
    { id: 3, key: 3, name: '承办单位', sort: 4, hide: 1 },
    { id: 5, key: 5, name: '指导单位', sort: 5, hide: 1 },
    { id: 7, key: 7, name: '战略合作', sort: 6, hide: 1 },
    { id: 6, key: 6, name: '特别支持', sort: 7, hide: 1 },
    { id: 8, key: 8, name: '鸣谢', sort: 8, hide: 1 },
];
